/*
 * CELEBRATEVITAMINS CUSTOM — collapse the desktop product thumbnail column.
 * Shows the first 3 thumbnails of the selected variant plus a "+N" tile; clicking the
 * tile shows all thumbnails (and a "−" tile collapses them again). Keeps the gallery
 * short so the blocks under it (product finder) move up.
 * Loaded from snippets/theme-globals.liquid on product pages. Remove that line to revert.
 * Only touches the desktop gallery (.product__media-container.above-mobile).
 */
(function () {
  'use strict';

  var VISIBLE = 3;
  var LIST = '.product__media-container.above-mobile .product-thumbnails__items';
  var ITEM = '.product-thumbnails__item';

  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = {
    nl: { more: 'Toon alle afbeeldingen', less: 'Toon minder afbeeldingen' },
    de: { more: 'Alle Bilder anzeigen', less: 'Weniger Bilder anzeigen' },
    en: { more: 'Show all images', less: 'Show fewer images' }
  }[lang] || { more: 'Show all images', less: 'Show fewer images' };

  // Thumbnails the theme currently shows (it hides other variants' images itself).
  function shown(list) {
    return Array.prototype.filter.call(list.querySelectorAll(ITEM), function (li) {
      li.classList.remove('cv-thumb-hidden');
      return !li.hidden && getComputedStyle(li).display !== 'none';
    });
  }

  var mo = null;

  function apply(list) {
    var items = shown(list);
    var tile = list.querySelector('.cv-thumb-more');
    var overflow = items.length - VISIBLE;

    if (overflow <= 0) {
      if (tile) tile.remove();
      return;
    }

    // Never hide the image that is currently selected.
    var activeIndex = -1;
    items.forEach(function (li, i) {
      if (li.querySelector('.active, [aria-current="true"]')) activeIndex = i;
    });
    // Open once when the selected image moves past the first 3 (e.g. variant switch);
    // after that the shopper can still collapse it.
    if (activeIndex >= VISIBLE && activeIndex !== list.__cvActive) list.__cvOpen = true;
    list.__cvActive = activeIndex;

    var open = !!list.__cvOpen;
    items.forEach(function (li, i) {
      if (!open && i >= VISIBLE) li.classList.add('cv-thumb-hidden');
    });

    if (!tile) {
      tile = document.createElement('li');
      tile.className = 'cv-thumb-more';
      tile.innerHTML = '<button type="button" class="cv-thumb-more__btn"></button>';
      tile.firstChild.addEventListener('click', function () {
        list.__cvOpen = !list.__cvOpen;
        run();
      });
    }
    // Keep the tile directly after the last visible thumbnail.
    var anchor = open ? items[items.length - 1] : items[VISIBLE - 1];
    if (anchor.nextSibling !== tile) anchor.parentNode.insertBefore(tile, anchor.nextSibling);

    var btn = tile.firstChild;
    btn.textContent = open ? '−' : '+' + overflow;
    btn.setAttribute('aria-label', open ? T.less : T.more);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function run() {
    document.querySelectorAll(LIST).forEach(apply);
    // Drop the mutations this pass caused itself, so the observer doesn't loop.
    if (mo) mo.takeRecords();
  }

  function init() {
    run();
    // The theme swaps thumbnails on variant change (classes, attributes or re-render).
    var t;
    mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 50);
    });
    var root = document.querySelector('.product__primary-left') || document.body;
    mo.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    document.addEventListener('product:variant-change', function () { setTimeout(run, 50); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
